import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<svg id="Layer_1" height="100%" viewBox="0 0 24 24" width="100%" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m20.29 20.75h-16.58a2.46 2.46 0 0 1 -2.46-2.46v-2.29a.75.75 0 0 1 1.5 0v2.29a1 1 0 0 0 1 1h16.54a1 1 0 0 0 1-1v-2.29a.75.75 0 0 1 1.5 0v2.29a2.46 2.46 0 0 1 -2.5 2.46z"/><path d="m12 17.75a.76.76 0 0 1 -.75-.75v-12a.75.75 0 0 1 1.5 0v12a.76.76 0 0 1 -.75.75z"/><path d="m12 17.75a.74.74 0 0 1 -.47-.16l-5-4a.75.75 0 0 1 .94-1.18l4.53 3.59 4.53-3.63a.75.75 0 1 1 .94 1.18l-5 4a.74.74 0 0 1 -.47.2z"/></svg>`,
      }}
    />
  );
};
